import React from 'react'
import { Modal } from 'react-bootstrap'
import { POModalProp } from '../../types/item.mster.type'
import { Controller, useForm } from 'react-hook-form'
import Select from 'react-select'

const PoCreationProcess: React.FC<POModalProp> = ({ reloadDataSource, selectedIds, onClose, isOpen }) => {
    const safeSelectedIds = selectedIds ?? [];

    const vendorOptions = [
        { value: 1, label: 'Test Vendor' },
        { value: 2, label: 'Test' }
    ]

    const productOptions = [
        { value: 'gold_ring', label: 'Gold Ring' },
        { value: 'diamond_necklace', label: 'Diamond Necklace' }
    ]

    const { register, handleSubmit, control, formState: { errors, isSubmitting } } = useForm<any>();

    const onSubmitForm = (data: any) => {
        console.log("Form Submitted:", data)
    }




    return (
        <>
            <Modal
                show={isOpen}
                onHide={onClose}
                backdrop="static"
                dialogClassName="modal-dialog-centered"
                size="xl"
            >
                <Modal.Header closeButton>
                    <Modal.Title>PO Creation</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form onSubmit={handleSubmit(onSubmitForm)} className="w-full px-3">
                        <div className="row">
                            {/* Vendor */}
                            <div className="col-md-3 mb-1">
                                    <label className="form-label form-label-sm">
                                Vendor {true && <span className="text-danger">*</span>}
                            </label>
                                <Controller
                                    name="vendor"
                                    control={control}
                                    rules={{ required: 'Vendor is required' }}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            options={vendorOptions}
                                            value={vendorOptions.find(opt => opt.value === field.value) || null}
                                            onChange={(val: any) => field.onChange(val?.value)}
                                            placeholder="--Select vendor--"
                                            isClearable
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            styles={{
                                                control: (provided: any, state: any) => ({
                                                    ...provided,
                                                    minHeight: "27px",
                                                    height: "27px",
                                                    fontSize: "12px",
                                                    borderWidth: "1px",
                                                    borderRadius: "0.25rem",
                                                    padding: "0 2px",
                                                    borderColor: errors[field?.name]
                                                        ? "#ff6c6c"
                                                        : state.isFocused ? "#86b7fe" : "#ced4da",
                                                    "&:hover": {
                                                        borderColor: "#86b7fe",
                                                    },
                                                }),
                                                indicatorsContainer: (base: any) => ({
                                                    ...base,
                                                    height: "28px"
                                                }),
                                                dropdownIndicator: (base: any) => ({
                                                    ...base,
                                                    padding: "4px",
                                                    color: "#6c757d",
                                                    ":hover": { color: "#495057" }
                                                }),
                                                valueContainer: (base: any) => ({
                                                    ...base,
                                                    padding: "0 8px",
                                                }),
                                                input: (base: any) => ({
                                                    ...base,
                                                    margin: 0,
                                                    padding: 0,
                                                }),
                                            }}

                                        />
                                    )}
                                />
                                {errors.vendor && <p className="text-danger">{errors.vendor.message as string}</p>}
                            </div>

                            {/* Product */}
                            <div className="col-md-3 mb-1">
                                <label className="form-label form-label-sm">
                                    Product {true && <span className="text-danger">*</span>}
                                </label>
                                <Controller
                                    name="product"
                                    control={control}
                                    rules={{ required: 'Product is required' }}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            options={productOptions}
                                            value={productOptions.find(opt => opt.value === field.value) || null}
                                            onChange={(val: any) => field.onChange(val?.value)}
                                            placeholder="--Select product--"
                                            isClearable
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            styles={{
                                                control: (provided: any, state: any) => ({
                                                    ...provided,
                                                    minHeight: "27px",
                                                    height: "27px",
                                                    fontSize: "12px",
                                                    borderWidth: "1px",
                                                    borderRadius: "0.25rem",
                                                    padding: "0 2px",
                                                    borderColor: errors[field?.name]
                                                        ? "#ff6c6c"
                                                        : state.isFocused ? "#86b7fe" : "#ced4da",
                                                    "&:hover": {
                                                        borderColor: "#86b7fe",
                                                    },
                                                }),
                                                indicatorsContainer: (base: any) => ({
                                                    ...base,
                                                    height: "28px"
                                                }),
                                                dropdownIndicator: (base: any) => ({
                                                    ...base,
                                                    padding: "4px",
                                                    color: "#6c757d",
                                                    ":hover": { color: "#495057" }
                                                }),
                                                valueContainer: (base: any) => ({
                                                    ...base,
                                                    padding: "0 8px",
                                                }),
                                                input: (base: any) => ({
                                                    ...base,
                                                    margin: 0,
                                                    padding: 0,
                                                }),
                                            }}
                                        />
                                    )}
                                />
                                {errors.product && <p className="text-danger">{errors.product.message as string}</p>}
                            </div>

                            {/* Quantity */}
                            <div className="col-md-3 mb-1">
                                <label className="form-label form-label-sm">
                                    Quantity {true && <span className="text-danger">*</span>}
                                </label>
                                <input
                                    type="number"
                                    {...register("quantity", { required: "Quantity is required", min: 1 })}
                                    className={`form-control form-control-sm ${errors.quantity ? "is-invalid" : ""}`}
                                    placeholder="Quantity"
                                />
                                {errors.quantity && <p className="text-danger">{errors.quantity.message as string}</p>}
                            </div>

                            {/* Gold Weight */}
                            <div className="col-md-3 mb-1">
                                <label className="form-label form-label-sm">
                                    Gold Wt 
                                </label>
                                <input
                                    type="number"
                                    step="0.01"
                                    {...register("goldWeight")}
                                    className="form-control form-control-sm"
                                    placeholder="Gold Weight"
                                />
                                {errors.goldWeight && <p className="text-danger">{errors.goldWeight.message as string}</p>}
                            </div>

                            {/* Diamond Weight */}
                            <div className="col-md-3 mb-1">
                                <label className="form-label form-label-sm">
                                    Diamond Wt 
                                </label>
                                <input
                                    type="number"
                                    step="0.01"
                                    {...register("diamondWeight")}
                                    className="form-control form-control-sm"
                                    placeholder="Diamond Weight"
                                />
                                {errors.diamondWeight && <p className="text-danger">{errors.diamondWeight.message as string}</p>}
                            </div>

                            {/* Making Rate */}
                            {/* <div className="col-md-3 mb-1">
                                <label className="form-label form-label-sm">
                                    Making Rate 
                                </label>
                                <input
                                    type="number"
                                    step="0.01"
                                    {...register("makingRate")}
                                    className="form-control form-control-sm"
                                    placeholder="Making Rate"
                                />
                                {errors.makingRate && <p className="text-danger">{errors.makingRate.message as string}</p>}
                            </div>

                            <div className="col-md-3 mb-1">
                                  <label className="form-label form-label-sm">
                                Bag No. {true && <span className="text-danger">*</span>}
                            </label>
                                <input
                                    type="text"
                                    {...register("bagNumber")}
                                    className="form-control form-control-sm"
                                    placeholder="Bag Number (Optional)"
                                />
                            </div> */}
                        </div>

                        <div className="mt-3 d-flex align-items-center justify-content-end gap-2">
                            <button type="submit" className="btn add-btn" onClick={onClose}>Cancel</button>
                            <button type="submit" className="btn submit-btn">Create PO</button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default PoCreationProcess
